// eslint-disable-next-line no-shadow
export enum MessageTypeEnum {
  info,
  warning,
  error,
  success,
  performingAction
}
